import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { Userpilot } from 'userpilot';
let UserPilotMixin = class UserPilotMixin extends Vue {
    /**
     * Userpilot Identify Event
     * @author Edrick Valencia <Edrick@gorated.ph>
     * @since Version {0.99.1}
     *
     * Reference: https://docs.userpilot.com/article/22-install-userpilot-on-single-page-application-frameworks
     */
    userpilotIdentify(userId, content = {}) {
        Userpilot.identify(userId, content);
    }
    /**
     * Userpilot Track Event
     * @author Edrick Valencia <Edrick@gorated.ph>
     * @since Version {0.99.1}
     *
     * Reference: https://docs.userpilot.com/article/23-identify-users-track-custom-events
     */
    userpilotTrack(eventName, content = {}) {
        Userpilot.track(eventName, content);
    }
};
UserPilotMixin = __decorate([
    Component
], UserPilotMixin);
export default UserPilotMixin;
